import { CanDeactivateFn } from '@angular/router';
import { CanComponentDeactivate } from '../components/abstract.component';

// The router passes a null component when the route was activated while no outlet
// was attached (its component was never instantiated); nothing exists to veto, so allow.
export const solCanDeactivate: CanDeactivateFn<CanComponentDeactivate> = component =>
  component ? component.canDeactivate() : true;
